// extracted by mini-css-extract-plugin
export default {"slider":"SliderNews_slider__QJiwb","decorImgae":"SliderNews_decorImgae__Qmofg"};